import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import ProjectUpload from './pages/ProjectUpload';
import Profile from './pages/Profile';
import ProjectEvaluation from './pages/ProjectEvaluation';
import ErrorPage from './pages/ErrorPage';
import UnderConstruction from './pages/UnderConstruction';
import ProjectDetails from './pages/ProjectDetails';


const ProtectedRoute = ({ children, requireStudent }) => {
  const { user, loading, isStudent } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireStudent && !isStudent) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router basename='/stacktrack'>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/upload" 
            element={
              <ProtectedRoute requireStudent>
                <Layout>
                  <ProjectUpload />
                </Layout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/project/:id/evaluate" 
            element={
              <ProtectedRoute>
                <Layout>
                  <ProjectEvaluation />
                </Layout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/courses" 
            element={
              <ProtectedRoute>
                <Layout>
                  <UnderConstruction />
                </Layout>
              </ProtectedRoute>
            } 
          />

          <Route 
            path="/assignments" 
            element={
              <ProtectedRoute>
                <Layout>
                  <UnderConstruction />
                </Layout>
              </ProtectedRoute>
            } 
          />
          <Route
            path="/project/:id" 
            element={
              <ProtectedRoute>
                <Layout>
                  <ProjectDetails /> 
                </Layout>
              </ProtectedRoute>
            } 
          />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
